var App = App || {};

var ModalForm = function (container) {
    this.container = container;
    this.init();
};

ModalForm.prototype.init = function () {
    this.modal = $(this.container);
    this.modal.data('modalForm', this);
    this.form = $('form', this.container);
    this.errorsBlock = $('.alert-danger', this.container);
    this.successMessage = $('.success-message', this.container);
    this.subbmitButton = $('button[type="submit"]', this.container);
    this.hideOnSuccess = $('.hide-on-success', this.container);
    this.paymentButton = $('.payment-button', this.container);
    this.paymentForm = $('#payment-form', this.container);
    this.paymentFormLoader = this.paymentForm.prev('div');
    this.checkoutScriptLoaded = $('#checkoutScriptLoaded', this.container);
    this.robokassaLoaded = false;
    this.bind();
};

ModalForm.prototype.bind = function () {
    this.form.on('beforeSubmit', this.onSubmit.bind(this));
    this.form.on('ajaxComplete', function (jqXHR, textStatus) {
        if (textStatus.status === 400 && textStatus.responseText === "Bad Request (#400): Не удалось проверить переданные данные.") {
            document.location.reload();
        }
    })
    this.modal.on('show.bs.modal', this.onShowModal.bind(this));
    if (this.checkoutScriptLoaded.length && this.checkoutScriptLoaded.val() !== 1) {
        $.ajax({
            url: "https://yookassa.ru/checkout-widget/v1/checkout-widget.js",
            dataType: "script",
            timeout: 10 * 1000
        }).done(function () {
            this.checkoutScriptLoaded.val(window.YooMoneyCheckoutWidget ? 1 : 0);
        }.bind(this));
        $.ajax({
            url: "https://auth.robokassa.ru/Merchant/bundle/robokassa_iframe.js",
            dataType: "script",
            timeout: 10 * 1000
        }).done(function () {
            this.robokassaLoaded = true;
        }.bind(this));
    }
};

ModalForm.prototype.onShowModal = function () {
    this.successMessage.addClass('d-none');
    this.hideOnSuccess.removeClass('d-none');
    if (this.checkout) {
        this.checkout.destroy();
    }
    if (this.paymentForm.length > 0) {
        this.paymentForm.html('');
        this.paymentFormLoader.removeClass('d-none');
    }
};

ModalForm.prototype.onSuccess = function (data) {
    let promoCodeInput = $('#scenarioorderform-promocodecode');
    if (promoCodeInput.length) {
        promoCodeInput.val('').trigger('blur');
    }

    this.successMessage.removeClass('d-none');
    this.hideOnSuccess.addClass('d-none');
    this.form.trigger('reset');
    this.form.trigger('onSuccess');

    var eventData = {form: this.container.attr('id')};
    if (typeof questData !== 'undefined') {
        eventData['quest'] = questData;
    }

    if (typeof yaCounter41174354 !== 'undefined') {
        yaCounter41174354.reachGoal('submit-order', eventData);
    }
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({event: "formSubmit", quest: eventData.quest, form: eventData.form})
    }

    if (typeof data.redirect !== 'undefined') {
        this.paymentButton.attr('href', data.redirect);
        window.location.href = data.redirect;
    }

    if (typeof data.checkout !== 'undefined') {
        this.checkout = new window.YooMoneyCheckoutWidget({
            confirmation_token: data.checkout.confirmationToken,
            return_url: data.checkout.returnUrl,
            embedded_3ds: true,
            customization: {
                colors: {
                    controlPrimary: '#f77833',
                    controlPrimaryContent: '#fff'
                }
            },
            error_callback: function (error) {
                if (typeof window.Rollbar !== 'undefined') {
                    Rollbar.error("YooMoneyCheckoutWidget error", error);
                }
            }
        });
        this.checkout.render('payment-form')
            .then(() => {
                this.paymentFormLoader.addClass('d-none');
            });
    }

    if (typeof data.html !== 'undefined') {
        this.paymentFormLoader.addClass('d-none');
        this.paymentForm.html(data.html);
    }

    if (typeof data.rk !== 'undefined') {
        Robokassa.StartPayment(data.rk);
        this.container.modal('hide');
    }
};

ModalForm.prototype.onSubmit = function () {
    this.subbmitButton.attr('disabled', 'disabled');

    $.post(this.form.attr('action'), this.form.serialize())
        .done(function (data) {
            if (data.success) {
                this.onSuccess(data);
            } else {
                this.errorsBlock.removeClass('d-none').html(data.errorSummary);
            }
        }.bind(this))
        .fail(function (data) {
            console.log(data);
        }.bind(this))
        .always(function () {
            this.subbmitButton.attr('disabled', false);
        }.bind(this));

    return false;
};

$(function () {
    $('.kvestiks-form-modal').each(function () {
        new ModalForm($(this));
    });
});